import { CountsRouterSchema } from "./countsRouter"
import type { IFedExApiTypes } from "./fedexRouter"
import type { IPhoneVerificationApiTypes } from "./phoneVerificationRouter"
import type { IPostcodeApiTypes } from "./postcodeRouter"
import type { IDbPerfApiTypes } from "./dbPerfRouter"
import type { ILogsApiTypes } from "./logsRouter"
import type { IPermissionsAuditApiTypes } from "./permissionsAuditRouter"
import type { ISageImportPerfApiTypes } from "./sageImportPerfRouter"
import type { ISageImportLiveApiTypes } from "./sageImportLiveRouter"
import type { ISageImportRunApiTypes } from "./sageImportRunRouter"
import type { ISlimStockSyncApiTypes } from "./slimStockSyncRouter"
import type { IPriceBandProductsApiTypes } from "./priceBandProductsRouter"
import type { IGoodsReceiptBarscanLogApiTypes } from "./goodsReceiptBarscanLogRouter"
import type { ICustomerMergeApiTypes } from "./customerMergeRouter"
import type { IUserBranchApiTypes } from "./userBranchRouter"

// Add api types here
type ITypedRouters = IFedExApiTypes &
  IPhoneVerificationApiTypes &
  CountsRouterSchema &
  IPostcodeApiTypes &
  IDbPerfApiTypes &
  ILogsApiTypes &
  IPermissionsAuditApiTypes &
  ISageImportPerfApiTypes &
  ISageImportLiveApiTypes &
  ISageImportRunApiTypes &
  ISlimStockSyncApiTypes &
  IPriceBandProductsApiTypes &
  IGoodsReceiptBarscanLogApiTypes &
  ICustomerMergeApiTypes &
  IUserBranchApiTypes

export const webInterface = buildWebInterface({
  fedexListRates: true,
  fedexCreateShipment: true,
  fedexLoadTrackingInfoForDelivery: true,
  sendPhoneVerification: true,
  verifyPhoneNumber: true,
  fedexCancelShipmentForDelivery: true,
  counts: true,
  searchPostcodes: true,
  getPostcode: true,
  dbPerfSummary: true,
  dbPerfQueryHistory: true,
  logsSearch: true,
  logsFacets: true,
  logsHistogram: true,
  logsContext: true,
  permissionsAudit: true,
  sageImportPerfSummary: true,
  sageImportLive: true,
  sageImportRunBranches: true,
  sageImportRun: true,
  sageImportPerfStarts: true,
  sageImportPerfDetail: true,
  slimStockSyncRuns: true,
  slimStockSyncRunDetail: true,
  slimStockSyncTaskDetails: true,
  slimStockSyncDatabaseState: true,
  slimStockSyncTrigger: true,
  slimStockSyncResume: true,
  bulkSavePriceBandProducts: true,
  goodsReceiptBarscanLog: true,
  customerMergePreview: true,
  customerMerge: true,
  changeUserBranch: true,
})

function buildWebInterface<Name extends Record<keyof ITypedRouters, true>>(routes: Name) {
  type IApiRequest = <T>(path: string, data?: any) => Promise<T>

  type IWebInterface = {
    [K in keyof ITypedRouters]: (
      request: IApiRequest,
      data: Parameters<ITypedRouters[K]>[0],
    ) => Promise<ReturnType<ITypedRouters[K]>>
  }
  const webInterface: IWebInterface = {} as any

  for (const name of Object.keys(routes)) {
    // @ts-ignore
    webInterface[name] = async (request: IApiRequest, data: unknown) => {
      const response = await request(`/api/${name}`, data)

      if (typeof response === "object" && response && "error" in response) {
        const message =
          typeof response.error === "string" ? response.error : JSON.stringify(response.error)
        throw new Error(message)
      } else if (typeof response === "object" && response && "data" in response) {
        return response.data
      } else {
        console.error(response)
        throw new Error("Invalid response format")
      }
    }
  }

  return webInterface
}
